import React from "react";
import NumberFormat from "react-number-format";
import { Row, Card, CardBody, CardHeader, Col } from "reactstrap";
import useCurrentSaleStore from "stores/SaleStore";
import shallow from "zustand/shallow";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus } from "constants/Constants";
import { CurrencyInput } from "features/forms/components/InputElement";
import { useFromLocations } from "../../../../../../stores/LocalStorageHelper";
import useCurrentLeaseStore from "../../../../../../stores/LeaseStore";

const Currency = ({ value }) => {
	return (
		<NumberFormat
			value={value}
			thousandSeparator={true}
			decimalScale={2}
			fixedDecimalScale={true}
			prefix={"$"}
			isNumericString={true}
			displayType="text"
		/>
	);
};

const LsSummaryTax = () => {
	const state = useFromLocations("state");
	const { county } = useCurrentDealStore((state) => state, shallow);
	const { type } = useCurrentDealStore(
		(state) => ({ type: state.deal.type }),
		shallow
	);

	const {
		tax,
		totalTaxable,
		taxableAmount,
		salesTax,
		vit,
		businessTax,
		fetTax,
		userTax1,
		userTax2,
		userTax3,
		userTax4,
		userTax5,
		userTax6,
		fixedAmountTax,
		editFixedAmountTax,
	} = useCurrentSaleStore(
		(state) => ({
			tax: state.tax,
			taxableAmount: state.taxableAmount,
			totalTaxable: state.totalTaxable,
			salesTax: state.salesTax,
			vit: state.vit,
			businessTax: state.businessTax,
			fetTax: state.fetTax,
			userTax1: state.userTax1,
			userTax2: state.userTax2,
			userTax3: state.userTax3,
			userTax4: state.userTax4,
			userTax5: state.userTax5,
			userTax6: state.userTax6,
			fixedAmountTax: state.fixedAmountTax,
			editFixedAmountTax: state.editFixedAmountTax,
		}),
		shallow
	);
	const lease = useCurrentLeaseStore((state) => state, shallow);
	const TaxSplit = ({ userTax, taxName }) => {
		console.log(userTax, taxName);
		return (
			userTax > 0 && (
				<Row>
					<div className="col">{taxName}</div>
					<div className="justify-content-right">
						<Currency value={userTax} />
					</div>
				</Row>
			)
		);
	};
	const xCounty = county ? county.isTaxSplit : 0;
	console.log(xCounty);
	const ButtonCA_CDTFA = () => (
		<Col color="md-6" style={{ textAlign: "center" }}>
			<hr className="my-3 noDesktop" />
			<a
				className="btn btn-md btn-primary"
				href={"https://onlineservices.cdtfa.ca.gov"}
				target="_blank"
				rel="noopener noreferrer"
			>
				<i className="nc-icon nc-support-17" /> CDTFA Online Services
			</a>
		</Col>
	);
	const ButtonFL_TAX = () => (
		<Col color="md-6" style={{ textAlign: "center" }}>
			<hr className="my-3 noDesktop" />
			<a
				className="btn btn-md btn-primary"
				href={"https://ritx-fl-sales.bswa.net/"}
				target="_blank"
				rel="noopener noreferrer"
			>
				<i className="nc-icon nc-support-17" /> Florida Online Services
			</a>
		</Col>
	);

	return (
		<Card className="my-2 w-100">
			<CardHeader>
				<h3>Summary</h3>
			</CardHeader>
			<CardBody>
				<Row>
					<Col>
						<h5 className="">Sales Tax</h5>
					</Col>
					<div className="justify-content-right">
						<h5>
							<Currency value={lease.totTax} />
						</h5>
					</div>
				</Row>
				<Row className="mt-2">
					<Col>
						<h5>+ Fixed Tax Amount</h5>
					</Col>
					<CurrencyInput
						wholeRow
						value={fixedAmountTax}
						readOnly={type !== DealStatus.PENDING}
						onChange={(e) => editFixedAmountTax(e)}
						name="fixedAmountTax"
						label=""
						type="Currency"
						disableValidation
						style={{
							width: "130px",
							marginLeft: "auto",
							textAlign: "right",
							fontSize: "1.47em",
							height: "auto",
							padding: "0",
							paddingRight: "0.5px",
						}}
					/>
				</Row>
				{vit > 0 && (
					<>
						<Row>
							<div className="col">
								<h5 className="">+ VIT</h5>
							</div>
							<div className="justify-content-right">
								<h5 className="">
									<Currency value={vit} />
								</h5>
							</div>
						</Row>
						<hr />
					</>
				)}
				{fetTax > 0 && (
					<>
						<Row>
							<div className="col">
								<h5 className="">+ FET</h5>
							</div>
							<div className="justify-content-right">
								<h5 className="">
									<Currency value={fetTax} />
								</h5>
							</div>
						</Row>
						<hr />
					</>
				)}

				{businessTax > 0 && (
					<>
						<Row>
							<div className="col">
								<h5 className="">+ BusinessTax</h5>
							</div>
							<div className="justify-content-right">
								<h5 className="">
									<Currency value={businessTax} />
								</h5>
							</div>
						</Row>
						<hr className="mt-2" />
					</>
				)}
				<Row className="mt-2">
					<div className="col">
						<h5 className="">Total Tax</h5>
					</div>
					<div className="justify-content-right">
						<h5 className="">
							<Currency value={tax} />
						</h5>
					</div>
				</Row>
				<Row>
					<div className="col">Taxable Amount</div>
					<div className="justify-content-right">
						<Currency value={taxableAmount} />
					</div>
				</Row>
				{lease.taxAmtInDriveOff > 0 && (
					<Row>
						<div className="col">Tax on Reduction</div>
						<div className="justify-content-right">
							<Currency value={lease.taxAmtInDriveOff} />
						</div>
					</Row>
				)}
				{lease.deferredTax > 0 && (
					<Row>
						<div className="col">Tax on Deferred</div>
						<div className="justify-content-right">
							<Currency value={lease.deferredTax} />
						</div>
					</Row>
				)}

				{totalTaxable !== taxableAmount && lease.capSalesTax && (
					<Row>
						<div className="col">Total Taxable</div>
						<div className="justify-content-right">
							<Currency value={totalTaxable} />
						</div>
					</Row>
				)}

				{xCounty === true && (
					<>
						<TaxSplit userTax={userTax1} taxName={county?.userTaxName1} />
						<TaxSplit userTax={userTax2} taxName={county?.userTaxName2} />
						<TaxSplit userTax={userTax3} taxName={county?.userTaxName3} />
						<TaxSplit userTax={userTax4} taxName={county?.userTaxName4} />
						<TaxSplit userTax={userTax5} taxName={county?.userTaxName5} />
						<TaxSplit userTax={userTax6} taxName={county?.userTaxName6} />
					</>
				)}
				{state === "CA" && <ButtonCA_CDTFA />}
				{state === "FL" && <ButtonFL_TAX />}
			</CardBody>
		</Card>
	);
};

export default LsSummaryTax;
